module.exports = __webpack_public_path__ + "img/2.71657c0d.png";